module.exports = __webpack_public_path__ + "images/0c2d4251eca48fb59ca72f53655ee1e6.png";